import { useItemSet } from '@exam-management/common/item-set-provider';
import {
  QuestionPreviewCollapsible,
  EmptyItemSetQuestionOverlay,
} from '@exam-management/qcontent-management';
import { Flex, styled } from '@shared/components';
import { useMemo } from 'react';

import { ItemSetSubQuestionMoreMenu } from '../item-set-sub-question-more-menu';

const Wrapper = styled(Flex)(({ theme }) => ({
  gap: theme.spacing(4),
  flexDirection: 'column',
}));

export default function ItemSetSubQuestionPreview() {
  const { itemSet } = useItemSet();

  const { questions } = itemSet;

  const questionsWithQuestionGroup = useMemo(
    () =>
      [...(questions ?? [])]
        .map((question) => ({ ...question, questionGroup: itemSet }))
        .sort((a, b) => {
          return Number(a.groupOrder) - Number(b.groupOrder);
        }),
    [questions],
  );

  if (!questions || questions.length === 0) {
    return <EmptyItemSetQuestionOverlay />;
  }

  return (
    <Wrapper>
      {questionsWithQuestionGroup.map((question) => (
        <QuestionPreviewCollapsible
          key={question.id}
          question={question}
          endAdornment={
            <ItemSetSubQuestionMoreMenu
              subQuestionId={question.id}
              structureId={question.refQBankStructureId}
            />
          }
        />
      ))}
    </Wrapper>
  );
}
